import { CSSProperties, FC, ReactNode } from 'react';
import styles from './index.module.less';

interface LayoutProps {
  actions?: ReactNode;
  children?: ReactNode;
  anchors?: ReactNode;
  id?: string;
  bodyStyle?: CSSProperties;
  actionStyle?: CSSProperties
}

const Layout: FC<LayoutProps> = ({ actions, children, anchors, id, bodyStyle, actionStyle }) => {
  return (
    <div className={styles[`layout-customer-wrapper`]} id={id}>
      <div className={styles['layout-customer']}>
        <div className={styles[`layout-customer-body-wrapper`]}>
          <div style={{ ...bodyStyle, }} className={styles[`layout-customer-body`]}>{children}</div>
          {anchors && <div className={styles[`layout-customer-anchor`]}>{anchors}</div>}
        </div>
        {actions && (
          <div className={styles[`layout-customer-action-wrapper`]} style={actionStyle}>
            <div className={styles[`layout-customer-action`]}>{actions}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
